var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#475467",
    d: "m15.728 9.577-1.414-1.414L5 17.476v1.415h1.414l9.314-9.314Zm1.414-1.414 1.414-1.415-1.414-1.414-1.414 1.414 1.414 1.415Zm-9.9 12.727H3v-4.242L16.435 3.213a1 1 0 0 1 1.414 0l2.829 2.828a1 1 0 0 1 0 1.414L7.243 20.891Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditTextIcon);
export default __webpack_public_path__ + "static/media/edit-text-icon.d0547f55d50a347e40f00619ed152b03.svg";
export { ForwardRef as ReactComponent };